import type { OrderEvent } from "../../types/orderEvent";
import { type ProgressWSInterface, type ProgressWSOptions } from "./progressWSInterface";

export default class DummyProgressWS implements ProgressWSInterface {
  public onStatusUpdate: ((event: OrderEvent) => void);
  public jwt: string;
  public internalProcessKey: string | undefined;
  
  constructor({ onStatusUpdate, jwt, internalProcessKey }: ProgressWSOptions) {
    this.jwt = jwt;
    this.internalProcessKey = internalProcessKey;
    this.onStatusUpdate = onStatusUpdate;
  }

  connect() {
    this.onStatusUpdate?.({
      status: "picking-up",
      event: "",
      external_order_id: "",
      api: "doordash_drive",
      timestamp: "",
      pickup: {
        // Fooji HQ
        latitude: 38.0334412,
        longitude: -84.4936979
      },
      destination: {
        // Fooji HQ
        latitude: 38.0445274,
        longitude: -84.4951775
      },
      carrier_message: "",
      location_human: "",
      estimated_delivered_at: "2024-01-01T00:00:00Z"
    });
  }

  disconnect() {
    console.log("disconnecting from websocket ...");
  }
}
